import { render, staticRenderFns } from "./EditDealer/template.html?vue&type=template&id=6b8cb56a&scoped=true&"
import script from "./EditDealer/script.ts?vue&type=script&lang=js&"
export * from "./EditDealer/script.ts?vue&type=script&lang=js&"
import style0 from "./EditDealer/style.scss?vue&type=style&index=0&id=6b8cb56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8cb56a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
